// Handles legacy routes to the old common-core routes
// We used to have common core routes and how they should redirect (examples):
//
// /commoncore/grade-1         => /standards/CCSS.Math/1
// /commoncore/grade-1-G       => /standards/CCSS.Math/1.G
// /commoncore/grade-HSA-A-SSE => /standards/CCSS.Math/HSA.SSE
//
import * as React from "react";
import {Redirect} from "react-router-dom";

type Props = {
    legacyCode: string;
};

const BASE_CCSS_URL = "/standards/CCSS.Math";
const KNOWN_REPLACEMENTS = {
    "-HSN-N-": "-HSN-",
    "-HSA-A-": "-HSA-",
    "-HSF-F-": "-HSF-",
    "-HSG-G-": "-HSG-",
    "-HSS-S-": "-HSS-",
} as const;

export default function LegacyCommonCoreRedirect({
    legacyCode,
}: Props): React.ReactElement {
    let redirectUrl = BASE_CCSS_URL;

    // Start by replacing some known sections where the legacy route had an
    // extra letter in the middle of the standard code for some reason.
    for (const [old, replacement] of Object.entries(KNOWN_REPLACEMENTS)) {
        legacyCode = legacyCode.replace(old, replacement);
    }

    const tokens = legacyCode.split("-");
    if (tokens[0] === "grade" && tokens.length >= 2) {
        redirectUrl += "/" + tokens[1];

        if (tokens.length >= 3) {
            redirectUrl += "." + tokens[2];
        }
    }

    return <Redirect to={redirectUrl} />;
}
